import React from "react"
import type { ChakraProps } from "@chakra-ui/react"

import { subheading } from "./SubHeading.css"
import { fontVariants, desktopVariants } from "../common.css"

type Props = ChakraProps & {
  subHeading: string
  modulePosition: number
  displayCheck?: boolean
  color?: string
  desktopColor?: string
}

export const SubHeading: React.FC<Props> = ({
  subHeading,
  modulePosition,
  displayCheck,
  color,
  desktopColor,
}) => {
  const headingClass = `${subheading} ${displayCheck} ${
    fontVariants[color ?? "Black"]
  } ${desktopVariants[desktopColor ?? color ?? "Black"]}`
  return modulePosition === 1 ? (
    <h2 className={headingClass}>{subHeading}</h2>
  ) : (
    <h3 className={headingClass}>{subHeading}</h3>
  )
}
